/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Onl_How_2_DescInputs */

const en_vc_onl_how_2_desc = /** @type {(inputs: Vc_Onl_How_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open SVG, PDF or .ai files from your disk, and Save or Export downloads the file back to your computer.`)
};

const zh_vc_onl_how_2_desc = /** @type {(inputs: Vc_Onl_How_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从硬盘打开 SVG、PDF 或 .ai 文件；点击保存或导出，文件会下载回你的电脑。`)
};

/**
* | output |
* | --- |
* | "Open SVG, PDF or .ai files from your disk, and Save or Export downloads the file back to your computer." |
*
* @param {Vc_Onl_How_2_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_onl_how_2_desc = /** @type {((inputs?: Vc_Onl_How_2_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Onl_How_2_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_onl_how_2_desc(inputs)
	return zh_vc_onl_how_2_desc(inputs)
});
export { vc_onl_how_2_desc as "vc.onl.how.2.desc" }